import { useLoaderData } from 'react-router';
import { BackLink } from '@/components/back-link';
import { api } from '@/lib/api';
import { FlowBuilder } from './flow-builder';

export async function newFlowLoader() {
  const [templates, segments] = await Promise.all([
    api<{ id: string; name: string; kind: string }[]>('/templates'),
    api<{ id: string; name: string; kind: string }[]>('/segments'),
  ]);
  return { templates, segments };
}

export function NewFlowPage() {
  const { templates, segments } = useLoaderData<typeof newFlowLoader>();
  return (
    <div className="space-y-5">
      <BackLink to="/flows">Flows</BackLink>
      <h1 className="text-2xl">New flow</h1>
      <FlowBuilder templates={templates} segments={segments} />
    </div>
  );
}
